import React from "react";
import { useSelector } from "react-redux";
import UsefulTool, { getUsefulToolLink } from "../../usefulTool/UsefulTool";
import NavigateLink from "../../navigateLink/navigateLink";
import Tooltip from "../../../ui/tooltip/Tooltip";
import toolActionsType from "../../../../enums/toolActionsType";
import gaSectionType from "../../../../enums/gaSectionType";
import ToolHoverActions from "../toolHoverActions/ToolHoverActions";
import ToolDotsActions from "../toolDotsActions/ToolDotsActions";
import classes from "./ToolsListItem.module.css";

const ToolsListItem = ({ tool, lang, onEdit, onDelete, actionsType = toolActionsType.hover }) => {

    const { userDetails } = useSelector(state => state.auth);
    const toolLink = getUsefulToolLink(tool, userDetails);
    const hasActions = onEdit || onDelete;

    const renderContent = () => {
        return (
            <div className={`${classes.ToolItem} ${hasActions ? classes.ToolItemWithActions : ""}`}>
                <div className={classes.ToolIconDesktop}>
                    <UsefulTool tool={tool} />
                </div>
                <div className={classes.ToolIconMobile}>
                    <UsefulTool tool={tool} size="small" />
                </div>
                <Tooltip showTooltip={tool?.description ? true : false} text={tool?.description?.[lang] ?? tool?.description}>
                    <p className={classes.Text}>{tool.name}</p>
                </Tooltip>
                {hasActions && actionsType === toolActionsType.hover &&
                    <ToolHoverActions
                        tool={tool}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        containerClass={classes.HoverActions}
                    />
                }
                {hasActions && actionsType === toolActionsType.dots &&
                    <ToolDotsActions
                        tool={tool}
                        onEdit={onEdit}
                        onDelete={onDelete}
                    />
                }
            </div>
        )
    }
    return (
        toolLink ?
            <div className={classes.ToolLink}>
                <NavigateLink link={toolLink} ga={{ section: gaSectionType.tools }}>
                    {renderContent()}
                </NavigateLink>
            </div>
            :
            renderContent()
    );
};

export default ToolsListItem;
